import clearFileProviderItems from './clearFileProviderItems';
import { incrementGetFileProviderItemsRequestCount } from './helpers/getFileProviderItemsRequestCount';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import setDefaultSort from './setDefaultSort';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import { logUsage } from 'owa-analytics';
import { ClientOnlyFileProviderType } from 'owa-fileprovider-store';
import { lazyClearSearchBox, SearchScenarioId } from 'owa-search';
import { action } from 'satcheljs/lib/legacy';
import {
    FolderItemViewState,
    FileProviderItemType,
    GroupItemViewState,
} from '../store/schema/FileProviderItemViewState';

export default action('changeSelectedFolder')(async function changeSelectedFolder(
    folder: FolderItemViewState | GroupItemViewState,
    viewState: FilePickerPanelViewState
) {
    const isWeSpace: boolean =
        viewState.selectedFileProvider.viewType === ClientOnlyFileProviderType.Groups;
    logUsage('FPChangeSelectedFolder', [
        isWeSpace,
        viewState.selectedFileProvider.type,
        viewState.filePickerViewState.searchViewState.isInSearchMode,
    ]);

    if (folder && folder.type === FileProviderItemType.Group) {
        viewState.filePickerViewState.pagingMetadata = folder.pagingMetadata;
    } else {
        if (viewState.filePickerViewState.breadcrumbs.length <= 1) {
            viewState.filePickerViewState.pagingMetadata = null;
        }
    }

    // Clear out of any search we were possibly doing. Note: We have to do this regardless of
    // if we are in a search or not, since we still want to reset the search state
    // if the user has typed in the search bar, but not started a search.
    const clearSearchBox = await lazyClearSearchBox.import();
    clearSearchBox(SearchScenarioId.FilesPicker);

    incrementGetFileProviderItemsRequestCount();
    viewState.filePickerViewState.selectedFolder = folder as FolderItemViewState;
    setDefaultSort(viewState.filePickerViewState);
    clearFileProviderItems(viewState.filePickerViewState);
    loadMoreItemsForSelectedProvider(viewState);
});
